import React from 'react'

const FormSection = ({children}) => (
  <div className="form-section">
    {children}
  </div>
)

export default FormSection
